export const messages = {
  page: {
    title: {
      id: 'signup.CreateAccount.Page.Title',
      defaultMessage: 'Now, let\'s create your account',
    },
  },
  form: {
    email: {
      id: 'signup.CreateAccount.Label.Email',
      defaultMessage: 'Enter your email address',
    },
    username: {
      id: 'signup.CreateAccount.Label.UserName',
      defaultMessage: 'Create your username',
    },
    password: {
      id: 'signup.CreateAccount.Label.Password',
      defaultMessage: 'Create your password',
    },
    confirmPassword: {
      id: 'signup.CreateAccount.Label.ConfirmPassword',
      defaultMessage: 'Confirm your password',
    },
    emailHelp: {
      id: 'signup.CreateAccount.Form.EmailHelp',
      defaultMessage: 'We need this if you ever forget your password.',
    },
    usernameHelp: {
      id: 'signup.CreateAccount.Form.UserNameHelp',
      defaultMessage: 'We recommend that you use your email address as your username.',
    },
    duplicateUsername: {
      id: 'signup.CreateAccount.Error.DuplicateUserName',
      defaultMessage: 'Username is already taken.',
    },
  },
  button: {
    createAccount: {
      id: 'signup.CreateAccount.Button.CreateAccount',
      defaultMessage: 'Create my account',
    },
    cancel: {
      id: 'signup.CreateAccount.Button.Cancel',
      defaultMessage: 'Cancel',
    },
  },
  checkbox: {
    accept: {
      id: 'signup.CreateAccount.Checkbox.Accept',
      defaultMessage: 'I accept the |{link}|',
    },
    tou: {
      id: 'signup.CreateAccount.Link.TermsOfUse',
      defaultMessage: 'Terms of Use',
    },
  },
  password: {
    format: {
      id: 'signup.CreateAccount.Password.Format',
      defaultMessage: '{description} {delimitedList}',
    },
    description: {
      id: 'signup.CreateAccount.Password.Description',
      defaultMessage: 'Use at least ',
    },
    minLength: {
      id: 'signup.CreateAccount.Password.MinLength',
      defaultMessage: `{minLength} {minLength, plural, one {character} other {characters}},
                      `,
    },
    capitalLetters: {
      id: 'signup.CreateAccount.Password.CapitalLetters',
      defaultMessage: `, {capitalLetters} capital {capitalLetters, plural, one {letter} other {letters}}
                      `,
    },
    numbers: {
      id: 'signup.CreateAccount.Password.Numbers',
      defaultMessage: `, {numbers} {numbers, plural, one {number} other {numbers}}
                      `,
    },
    specialCharacters: {
      id: 'signup.CreateAccount.Password.SpecialCharacters',
      defaultMessage: `, {specialCharacters} special {specialCharacters, plural, one {character} other {characters}}
                      ! @ # $ % & ) ( + `,
    },
  },
  error: {
    email: {
      id: 'signup.CreateAccount.Error.Email',
      defaultMessage: 'Email address is not in correct format.',
    },
    username: {
      id: 'signup.CreateAccount.Error.UserName',
      defaultMessage: 'Invalid username format',
    },
    password: {
      id: 'signup.CreateAccount.Error.Password',
      defaultMessage: 'Password does not meet security requirements.',
    },
    confirmPassword: {
      id: 'signup.CreateAccount.Error.ConfirmPassword',
      defaultMessage: 'Passwords do not match.',
    },
    tou: {
      id: 'signup.CreateAccount.Error.TermsOfUse',
      defaultMessage: 'You must accept the terms of use to create an account.',
    },
  },
};
